// Angular Files
import {
 Component, HostBinding, Input, NgModule
} from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material Files
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

// Teller Online Files
import { ConvenienceFeeConfigModel } from 'apps/public-portal/src/app/payment-integrations/base/models';

// Teller Online Library Files
import { TellerOnlineIconsModule } from 'teller-online-libraries/icons';
import { TellerOnlineMessageService } from 'teller-online-libraries/shared';

@Component({
    selector: 'app-cart-summary-totals',
    templateUrl: './cart-summary-totals.component.html',
    styleUrls: ['./cart-summary-totals.component.scss'],
    host: { class: 'cart-summary-totals' },
    standalone: false
})
export class CartSummaryTotalsComponent {
    @Input() subtotal: number;

    @Input() convenienceFee: number;

    @Input() total: number;

    @Input() feeConfig: ConvenienceFeeConfigModel;

    @Input() calculating: boolean = false;

    @Input() checkoutEnabled: boolean = true;

    @Input() showDividerBeforeTotal: boolean = false;

    @Input() iconSize: number = 18;

    constructor(private messageService: TellerOnlineMessageService) {}

    @HostBinding('class.has-convenience-fee')
    get shouldShowConvenienceFee(): boolean {
        return this.feeConfig?.enabled && (this.convenienceFee != null || !!this.feeConfig?.note);
    }

    onClick_showConvenienceFeeNote(): void {
        this.messageService.alert(
            this.feeConfig.note,
            this.feeConfig.label ?? 'Convenience Fee',
            'cart-convenience-fee-modal'
        );
    }
}

@NgModule({
    declarations: [CartSummaryTotalsComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatDividerModule,
        TellerOnlineIconsModule
    ],
    exports: [CartSummaryTotalsComponent]
})
export class CartSummaryTotalsModule {}
